










import { defineComponent, PropType } from "@vue/composition-api";
import { PurchasedItemProvider } from "@scrile/api-provider/dist/api/PurchasedItemsProvider";
import BasePage from "@/components/BasePage";
import EmptyContent from "@/components/EmptyContent";
import InfiniteScroll from "@/components/InfiniteScroll";
import PageTitle from "@/components/PageTitle";
import PurchaseGalleryProvider from "../PurchaseGalleryProvider";

export default defineComponent({
  name: "PurchaseGalleryProvidersView",

  components: { PurchaseGalleryProvider, InfiniteScroll, EmptyContent, BasePage, PageTitle },
  props: {
    loading: { type: Boolean, default: false },
    items: { type: Array as PropType<PurchasedItemProvider[]>, required: true },
    enableScroll: { type: Boolean, default: true },
  },
});
